export const API_ROOT = {
  development: 'http://api-test.huna.live',
  development2: 'http://api-test.huna.live',
  test: 'http://api-test.huna.live',
  test2: 'http://api-test.huna.live',
  production: 'http://api.huna.live',
  production2: 'http://api-in.kissoclub.com',
  production3: 'http://api.huna.live',
  production4: 'http://api.frdyo.com',
}[ENVIRONMENT]

export const API_PREFIX = '/api'
